import { createApi, split } from 'effector';
import produce from 'immer';
import domain from '../domain';
import libReset from '../actions/libReset';
import onAlbumClick from '../actions/onAlbumClick';
import { LibMultipleGate } from './libState';
import onItemClick from '../actions/onItemClick';

const singleSelect = domain.event<number>();
const multipleSelect = domain.event<number>();

split({
  source: onItemClick,
  match: {
    multiple: LibMultipleGate.state,
  },
  cases: {
    multiple: multipleSelect,
    __: singleSelect,
  },
});

export const $libSelected = domain
  .store<number[]>([])
  .on(singleSelect, (state, id) => {
    return state.includes(id) ? [] : [id];
  })
  .on(multipleSelect, (state, id) => {
    return produce(state, (draft) => {
      const index = draft.indexOf(id);
      if (index >= 0) {
        draft.splice(index, 1);
      } else {
        draft.push(id);
      }
    });
  })
  .reset(libReset, onAlbumClick);
export const $libSelectedApi = createApi($libSelected, {
  set: (_, ids: number[]) => ids,
  clear: () => [],
});
